<template>
    <div id="student-app">
        <student-navbar></student-navbar>
        <router-view :user="getUser" />
        <student-footer></student-footer>
    </div>
</template>

<script>
import auth from '../../js/auth';

import StudentFooter from '../../components/Student/Footer';
import StudentNavbar from '../../components/Student/Navbar.vue';

export default {
    name: 'student-app',
    components: {
        StudentFooter,
        StudentNavbar
    },
    computed: {
        getUser() {
            return auth.getUser() || {};
        }
    }
}
</script>